// Auto-detect API URL based on how the app is accessed
// Browser on localhost → localhost:5001, iPhone on LAN → same-host:5001
export function getApiUrl() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL + '/api';
  }
  const host = window.location.hostname;
  // Only use HTTP for localhost dev; all other hosts use HTTPS
  const protocol = (host === 'localhost' || host === '127.0.0.1') ? 'http' : 'https';
  return `${protocol}://${host}:5001/api`;
}

// Same as getApiUrl but WITHOUT /api suffix (for files that append /api/ themselves)
export function getApiBase() {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const host = window.location.hostname;
  const protocol = (host === 'localhost' || host === '127.0.0.1') ? 'http' : 'https';
  return `${protocol}://${host}:5001`;
}

export function createPageUrl(pageName) {
  // Handle special cases with dashes
  const specialCases = {
    'VisualSearch': '/visual-search',
    'MyWardrobe': '/my-wardrobe',
    'AIStylist': '/ai-stylist'
  };
  
  if (specialCases[pageName]) {
    return specialCases[pageName];
  }
  
  return `/${pageName.toLowerCase()}`;
}

// Currency management — stored in localStorage
const CURRENCY_KEY = 'preferredCurrency';

const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar', locale: 'en-US' },
  { code: 'EUR', symbol: '€', name: 'Euro', locale: 'de-DE' },
  { code: 'GBP', symbol: '£', name: 'British Pound', locale: 'en-GB' },
  { code: 'CAD', symbol: 'CA$', name: 'Canadian Dollar', locale: 'en-CA' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar', locale: 'en-AU' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc', locale: 'de-CH' },
  { code: 'SEK', symbol: 'kr', name: 'Swedish Krona', locale: 'sv-SE' },
  { code: 'DKK', symbol: 'kr', name: 'Danish Krone', locale: 'da-DK' },
  { code: 'NOK', symbol: 'kr', name: 'Norwegian Krone', locale: 'nb-NO' },
  { code: 'PLN', symbol: 'zł', name: 'Polish Zloty', locale: 'pl-PL' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen', locale: 'ja-JP' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan', locale: 'zh-CN' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee', locale: 'en-IN' },
  { code: 'BRL', symbol: 'R$', name: 'Brazilian Real', locale: 'pt-BR' },
  { code: 'MXN', symbol: 'MX$', name: 'Mexican Peso', locale: 'es-MX' },
  { code: 'TRY', symbol: '₺', name: 'Turkish Lira', locale: 'tr-TR' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham', locale: 'ar-AE' },
];

export function getSupportedCurrencies() {
  return CURRENCIES;
}

export function getCurrency() {
  return localStorage.getItem(CURRENCY_KEY) || 'USD';
}

export function setCurrency(code) {
  localStorage.setItem(CURRENCY_KEY, code);
  // Dispatch event so components can react
  window.dispatchEvent(new CustomEvent('currencyChange', { detail: code }));
}

export function getCurrencySymbol(code) {
  const c = CURRENCIES.find(c => c.code === (code || getCurrency()));
  return c ? c.symbol : '$';
}

export function formatPrice(price, currencyCode) {
  const code = currencyCode || getCurrency();
  const c = CURRENCIES.find(c => c.code === code);
  const symbol = c ? c.symbol : '$';
  const num = parseFloat(price) || 0;
  // For JPY, no decimal places
  if (code === 'JPY') return `${symbol}${Math.round(num).toLocaleString()}`;
  return `${symbol}${num.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}
